export default {
    emailconfig: {
      name: 'การกำหนดค่าอีเมล',
      fields: {
        title: 'ชื่อ, นามสกุล หรือ อีเมล',
        name: 'ชื่อ-นามสกุล',
        first_name: 'ชื่อ',
        last_name: 'นามสกุล',
        email: 'อีเมล',
        active: 'สถานะ',
      },
      create: { title: 'สร้างการกำหนดค่าอีเมล' },
      edit: { title: 'แก้ไขการกำหนดค่าอีเมล' },
    },
  }
  